import HookFormTextField from 'reservations/form/components/HookFormTextField';

type EmailFormFieldProps = {
  handleOnBlur?: (value: string) => void;
};

function EmailFormField({ handleOnBlur }: EmailFormFieldProps) {
  return (
    <HookFormTextField
      name="email"
      label="Email"
      handleOnBlur={handleOnBlur}
      required
    />
  );
}

export default EmailFormField;
